import { HttpStatusCode } from "axios";
import apiClient from "../api/ApiClient";
import { ApiEndpoints } from "../../config/constants";
import { UserWithRole, UpdateUserDto } from "../../models/User";
import { userRolesStore } from "../../app/stores/UserRoles";

export const UsersService = () => {
    // Get store actions
    const { 
        updateUsers, 
        addUser,
        updateUser: updateUserInStore, 
        removeUser, 
        setLoading, 
        setError 
    } = userRolesStore.getState();

    // GET ALL USERS
    const getAllUsers = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiClient.get<{ data: UserWithRole[] }>(ApiEndpoints.Users.GetAllUsers);
            
            if (response.status === HttpStatusCode.Ok && response.data.data) {
                updateUsers(response.data.data);
                setLoading(false);
                return;
            }

            setError("Failed to fetch users");
            setLoading(false);
        } catch (error: any) {
            setError(error.message || "Failed to fetch users");
            setLoading(false);
        }
    };

    // UPDATE USER 
    const updateUserRole = async (userId: string, updates: UpdateUserDto) => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiClient.put<{ data: UserWithRole }>(ApiEndpoints.Users.UpdateUser(userId), updates);
            
            if (response.status === HttpStatusCode.Ok && response.data.data) {
                const updatedUser = response.data.data;
                updateUserInStore(userId, updatedUser);
                setLoading(false);
                return updatedUser;
            }

            setError("Failed to update user");
            setLoading(false);
            return null;
        } catch (error: any) {
            setError(error.message || "Failed to update user");
            setLoading(false);
            return null;
        }
    };

    // DELETE USER
    const deleteUser = async (userId: string) => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiClient.delete(ApiEndpoints.Users.DeleteUser(userId));
            
            if (response.status === HttpStatusCode.Ok) {
                removeUser(userId);
                setLoading(false);
                return true;
            }
            
            setError("Failed to delete user");
            setLoading(false);
            return false;
        } catch (error: any) {
            setError(error.message || "Failed to delete user");
            setLoading(false);
            return false;
        }
    };

    return { 
        getAllUsers,
        updateUserRole,
        deleteUser
    };
};
